import React from "react";
import PropTypes from "prop-types";

const RegisterMarqueeView = () =>
  <div className="text-center mb-0" style={{ backgroundColor: "#FFC000", color: "#fff", height: "2.5rem", lineHeight: "2.5rem" }}>
    <strong>¡Bienvenido a Workix!</strong> Por favor, regístrate para desbloquear todas las funciones.
    <a href="/signup" style={{ color: "#fff", textDecoration: "underline", marginLeft: "0.5rem" }}>Regístrate aquí</a>
  </div>;

RegisterMarqueeView.propTypes = {};

export default RegisterMarqueeView;